import CommunicationCrudRequest from './CommunicationCrudRequest';

export default class PushCommunicationRequest extends CommunicationCrudRequest {
  static baseUrl() {
    return '/v1/mensagensComunicacao/push';
  }
}
